import React from 'react'
import PropTypes from 'prop-types'

// Lodash
import _map from 'lodash/map'

// Components
import { Menu as AntMenu, Dropdown } from 'antd'
import { MoreOutlined } from '@ant-design/icons'

// Styles
import 'antd/lib/menu/style/index.css'
import 'antd/lib/dropdown/style/index.css'
import styles from './kebabMenu.module.scss'

const MenuItem = AntMenu.Item

const renderMenuItem = (onClick) => (item, index) =>
  <MenuItem onClick={onClick} className={styles.menuItem} key={index}>{item}</MenuItem>

const renderOverlay = (menuItems, onClick) => (
  <AntMenu>{_map(menuItems, renderMenuItem(onClick))}</AntMenu>
)

const KebabMenu = (props) => {
  const { menuItems, onClick, ...restProps } = props

  const handleOnClick = (event) => {
    event.stopPropagation()
  }

  return (
    <Dropdown
      overlay={renderOverlay(menuItems, onClick)}
      trigger={['click']}
      onClick={handleOnClick}
      {...restProps}
    >
      <MoreOutlined className={styles.icon} />
    </Dropdown>
  )
}

KebabMenu.propTypes = {
  menuItems: PropTypes.array
}

KebabMenu.defaultProps = {
  menuItems: ['Remove']
}

export default KebabMenu
